<nav class="bottom-nav">
  @for (link of links; track link.route) {
    <a
      class="bottom-nav__link"
      [routerLink]="link.route"
      routerLinkActive="bottom-nav__link--active"
      [routerLinkActiveOptions]="{ exact: link.exact ?? false }"
    >
      @switch (link.route) {
        @case ("/dashboard") {
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M8.86719 2.65433C10.2681 1.56497 12.5161 1.47962 14.0195 2.43362L14.1631 2.52933L20.3428 6.85941L20.3438 6.86038C20.8578 7.21891 21.3399 7.80188 21.6934 8.47855C22.0468 9.15525 22.25 9.88377 22.25 10.5098V17.7901C22.25 20.2445 20.2532 22.25 17.79 22.25H6.20996C3.74753 22.25 1.75016 20.2453 1.75 17.7803V10.3701C1.75 9.78468 1.93357 9.09273 2.25391 8.44046C2.57412 7.78843 3.01035 7.21719 3.47656 6.85452H3.47754L8.86719 2.65433ZM11.5059 2.2764C10.674 2.29445 9.82026 2.54111 9.17285 3.04593L3.78223 7.24515L3.78027 7.2471C3.34867 7.58752 2.97224 8.11388 2.70508 8.65628C2.43822 9.19813 2.25 9.81835 2.25 10.3701V17.7803C2.25016 19.9644 4.02206 21.75 6.20996 21.75H17.79C19.9761 21.75 21.75 19.9762 21.75 17.7901V10.5098C21.75 9.9245 21.5449 9.27153 21.25 8.70609C20.956 8.14255 20.5387 7.60207 20.0557 7.27054H20.0566L13.877 2.94046C13.2028 2.46748 12.3377 2.25843 11.5059 2.2764Z"
              fill="currentColor"
              stroke="currentColor"
            />
            <path
              d="M12 14.75C12.1339 14.75 12.25 14.8661 12.25 15V18C12.25 18.1339 12.1339 18.25 12 18.25C11.8661 18.25 11.75 18.1339 11.75 18V15C11.75 14.8661 11.8661 14.75 12 14.75Z"
              fill="currentColor"
              stroke="currentColor"
            />
          </svg>
        }
        @case ("/categories") {
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M16.5 8.62999C16.09 8.62999 15.75 8.28999 15.75 7.87999V6.49999C15.75 5.44999 15.3 4.42999 14.52 3.71999C13.73 2.99999 12.71 2.66999 11.63 2.76999C9.83 2.93999 8.25 4.77999 8.25 6.69999V7.66999C8.25 8.07999 7.91 8.41999 7.5 8.41999C7.09 8.41999 6.75 8.07999 6.75 7.66999V6.68999C6.75 3.99999 8.92 1.51999 11.49 1.26999C12.99 1.12999 14.43 1.59999 15.53 2.60999C16.62 3.59999 17.25 5.01999 17.25 6.49999V7.87999C17.25 8.28999 16.91 8.62999 16.5 8.62999Z"
              fill="currentColor"
            />
            <path
              d="M14.9998 22.75H8.99982C4.37982 22.75 3.51982 20.6 3.29982 18.51L2.54982 12.52C2.43982 11.44 2.39982 9.89 3.44982 8.73C4.34982 7.73 5.83982 7.25 7.99982 7.25H15.9998C18.1698 7.25 19.6598 7.74 20.5498 8.73C21.5898 9.89 21.5598 11.44 21.4498 12.5L20.6998 18.51C20.4798 20.6 19.6198 22.75 14.9998 22.75ZM7.99982 8.75C6.30982 8.75 5.14982 9.08 4.55982 9.74C4.06982 10.28 3.90982 11.11 4.03982 12.35L4.78982 18.34C4.95982 19.94 5.39982 21.26 8.99982 21.26H14.9998C18.5998 21.26 19.0398 19.95 19.2098 18.36L19.9598 12.35C20.0898 11.13 19.9298 10.3 19.4398 9.75C18.8498 9.08 17.6898 8.75 15.9998 8.75H7.99982Z"
              fill="currentColor"
            />
            <path
              d="M15.4202 13.15C14.8602 13.15 14.4102 12.7 14.4102 12.15C14.4102 11.6 14.8602 11.15 15.4102 11.15C15.9602 11.15 16.4102 11.6 16.4102 12.15C16.4102 12.7 15.9702 13.15 15.4202 13.15Z"
              fill="currentColor"
            />
            <path
              d="M8.42016 13.15C7.86016 13.15 7.41016 12.7 7.41016 12.15C7.41016 11.6 7.86016 11.15 8.41016 11.15C8.96016 11.15 9.41016 11.6 9.41016 12.15C9.41016 12.7 8.97016 13.15 8.42016 13.15Z"
              fill="currentColor"
            />
          </svg>
        }
        @case ("/basket") {
          <span class="bottom-nav__badge-wrapper">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M18.19 17.75H7.53999C6.54999 17.75 5.59999 17.33 4.92999 16.6C4.25999 15.87 3.92 14.89 4 13.9L4.83 3.94C4.86 3.63 4.74999 3.33001 4.53999 3.10001C4.32999 2.87001 4.04 2.75 3.73 2.75H2C1.59 2.75 1.25 2.41 1.25 2C1.25 1.59 1.59 1.25 2 1.25H3.74001C4.47001 1.25 5.15999 1.56 5.64999 2.09C5.91999 2.39 6.12 2.74 6.23 3.13H18.72C19.73 3.13 20.66 3.53 21.34 4.25C22.01 4.98 22.35 5.93 22.27 6.94L21.73 14.44C21.62 16.27 20.02 17.75 18.19 17.75ZM6.28 4.62L5.5 14.02C5.45 14.6 5.64 15.15 6.03 15.58C6.42 16.01 6.95999 16.24 7.53999 16.24H18.19C19.23 16.24 20.17 15.36 20.25 14.32L20.79 6.82001C20.83 6.23001 20.64 5.67001 20.25 5.26001C19.86 4.84001 19.32 4.60999 18.73 4.60999H6.28V4.62Z"
                fill="currentColor"
              />
              <path
                d="M16.25 22.75C15.15 22.75 14.25 21.85 14.25 20.75C14.25 19.65 15.15 18.75 16.25 18.75C17.35 18.75 18.25 19.65 18.25 20.75C18.25 21.85 17.35 22.75 16.25 22.75ZM16.25 20.25C15.97 20.25 15.75 20.47 15.75 20.75C15.75 21.03 15.97 21.25 16.25 21.25C16.53 21.25 16.75 21.03 16.75 20.75C16.75 20.47 16.53 20.25 16.25 20.25Z"
                fill="currentColor"
              />
              <path
                d="M8.25 22.75C7.15 22.75 6.25 21.85 6.25 20.75C6.25 19.65 7.15 18.75 8.25 18.75C9.35 18.75 10.25 19.65 10.25 20.75C10.25 21.85 9.35 22.75 8.25 22.75ZM8.25 20.25C7.97 20.25 7.75 20.47 7.75 20.75C7.75 21.03 7.97 21.25 8.25 21.25C8.53 21.25 8.75 21.03 8.75 20.75C8.75 20.47 8.53 20.25 8.25 20.25Z"
                fill="currentColor"
              />
              <path
                d="M21 8.75H9C8.59 8.75 8.25 8.41 8.25 8C8.25 7.59 8.59 7.25 9 7.25H21C21.41 7.25 21.75 7.59 21.75 8C21.75 8.41 21.41 8.75 21 8.75Z"
                fill="currentColor"
              />
            </svg>
            @if (itemCount() > 0) {
              <ntt-badge
                class="bottom-nav__badge"
                color="success"
                size="sm"
                radius="circle"
                >{{ itemCount() }}</ntt-badge
              >
            }
          </span>
        }
        @case ("/orders") {
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M8 1.75H16C17.7301 1.75 19.0268 2.24555 19.8906 3.10938C20.7544 3.9732 21.25 5.26991 21.25 7V17C21.25 18.7301 20.7544 20.0268 19.8906 20.8906C19.0268 21.7544 17.7301 22.25 16 22.25H8C6.26991 22.25 4.9732 21.7544 4.10938 20.8906C3.24555 20.0268 2.75 18.7301 2.75 17V7C2.75 5.26991 3.24555 3.9732 4.10938 3.10938C4.9732 2.24555 6.26991 1.75 8 1.75ZM8 2.25C6.49651 2.25 5.28283 2.61561 4.44922 3.44922C3.61561 4.28283 3.25 5.49651 3.25 7V17C3.25 18.5035 3.61561 19.7172 4.44922 20.5508C5.28283 21.3844 6.49651 21.75 8 21.75H16C17.5035 21.75 18.7172 21.3844 19.5508 20.5508C20.3844 19.7172 20.75 18.5035 20.75 17V7C20.75 5.49651 20.3844 4.28283 19.5508 3.44922C18.7172 2.61561 17.5035 2.25 16 2.25H8Z"
              fill="currentColor"
              stroke="currentColor"
            />
            <path
              d="M14.5 4.25C14.6339 4.25 14.75 4.36614 14.75 4.5V6.5C14.75 7.46614 15.5339 8.25 16.5 8.25H18.5C18.6339 8.25 18.75 8.36614 18.75 8.5C18.75 8.63386 18.6339 8.75 18.5 8.75H16.5C15.2561 8.75 14.25 7.74386 14.25 6.5V4.5C14.25 4.36614 14.3661 4.25 14.5 4.25Z"
              fill="currentColor"
              stroke="currentColor"
            />
            <path
              d="M12 13.75H8C7.59 13.75 7.25 13.41 7.25 13C7.25 12.59 7.59 12.25 8 12.25H12C12.41 12.25 12.75 12.59 12.75 13C12.75 13.41 12.41 13.75 12 13.75Z"
              fill="currentColor"
            />
            <path
              d="M16 17.75H8C7.59 17.75 7.25 17.41 7.25 17C7.25 16.59 7.59 16.25 8 16.25H16C16.41 16.25 16.75 16.59 16.75 17C16.75 17.41 16.41 17.75 16 17.75Z"
              fill="currentColor"
            />
          </svg>
        }
      }
      <span class="bottom-nav__label text-xs-semi-bold">{{ link.label }}</span>
    </a>
  }
</nav>
